<template>
    <canvas ref="chart" :style="style" />
</template>

<script>
export default {
    name: 'QChart',
    props: ['id', 'style', 'type', 'labels', 'datasets', 'options'],
    data() {
        return {
            rendered: false,
            loading: false,
            chart: null,
            timeout: false,
        };
    },
    methods: {
        initChart() {
            if (
                (!this.datasets.length || !Object.keys(this.options).length) &&
                !this.rendered &&
                !this.timeout
            ) {
                this.timeout = setTimeout(() => {
                    this.initChart();
                    this.timeout = false;
                }, 500);
                return;
            }
            // console.log(this.datasets, this.options);
            this.loading = true;

            // return new Promise((resolve) => {
            this.chart = new this.ChartJS(this.$refs['chart'], {
                type: this.type,
                data: {
                    labels: this.labels,
                    datasets: this.datasets,
                },
                options: this.options,
            });
            // this.chart.update();
            // console.log(this.datasets, this.options);
            this.rendered = true;
            // resolve();
            // }).then(() => (this.loading = false));
        },
        redrawChart() {
            if (!(this.chart ?? false)) return;
            return this.chart.render();
        },
    },
    mounted() {
        this.initChart();
    },
    watch: {
        // datasets: {
        //     handler() {
        //         this.redrawChart();
        //     },
        //     deep: true,
        // },
    },
};
</script>

<style lang="scss">
#chart {
    letter-spacing: 0.75px;
}
</style>